export default __webpack_public_path__ + "static/media/agreement.e5294f33.png";